import { xhrStatusFactory } from 'redux/reusable/xhrStatus';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import type { State } from './roles.types';
import { fetchedRoles, withXhrStatusReducer } from './roles.types';

const initialState: State = {
  userRoles: [],
  xhrStatus: xhrStatusFactory(),
};

const reducer = reducerWithInitialState<State>(initialState).casesWithAction(
  [fetchedRoles],
  (state, action) => ({
    ...state,
    userRoles: action.payload,
  })
);

export default withXhrStatusReducer(reducer);
